import { useState } from 'react';
import toast from 'react-hot-toast';
import * as XLSX from 'xlsx';
import { getPlayers } from '../../../Api/Players/Players';

export const useExportPlayers = ({ filters }: { filters: any }) => {
    const [loadingExport, setLoadingExport] = useState(false)
    const exportToExcel = (data: any[], cajero: string) => {
        // Extracting the required columns
        const excelData = data.map(({ platformUser, firstName, lastName, phone, email, createdInPromo, createdAt, firstLoadValue }) => {
            return {
                'Fecha': createdAt,
                'Usuario': platformUser,
                'Nombre': firstName,
                'Apellido': lastName,
                'Teléfono': phone,
                'Email': email,
                'Creado en promo': createdInPromo ? 'Si' : 'No',
                'Primera Carga': firstLoadValue === 0 ? '' : firstLoadValue,
            };
        });

        // Creating a new workbook
        const wb = XLSX.utils.book_new();
        // Converting the data to a worksheet
        const ws = XLSX.utils.json_to_sheet(excelData);

        ws['!cols'] = [
            { wch: 15 }, // Fecha
            { wch: 20 }, // Usuario
            { wch: 25 }, // Nombre
            { wch: 25 }, // Apellido
            { wch: 20 }, // Teléfono
            { wch: 20 }, // Email
            { wch: 20 }, // Creado en promo
        ];

        // Adding the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, 'History');

        // Writing the workbook to a file
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

        // Convert string to a buffer
        const buffer = new ArrayBuffer(wbout.length);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < wbout.length; i++) {
            view[i] = wbout.charCodeAt(i) & 0xff;
        }

        // Save the file
        let today = new Date().toLocaleDateString();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        const fileName = `Jugadores ${today}.xlsx`;
        if (window.navigator.msSaveOrOpenBlob) {
            // For IE
            window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
            // For other browsers
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        }
    };


    const handleDownload = async () => {
        if (loadingExport) return
        toast.loading('Descargando datos...')
        setLoadingExport(true)
        const { startDate, endDate, createdInPromo, platformUser } = filters
        const res = await getPlayers({ pageSize: 100000, startDate, endDate, createdInPromo, platformUser: platformUser?.trim(), download: true })

        // Check no more than 2 months of range
        if (!startDate || !endDate) {
            toast.error('Debes seleccionar un rango de fechas')
            return
        }

        const startDateObj = new Date(startDate)
        const endDateObj = new Date(endDate)
        const diffTime = Math.abs(endDateObj.getTime() - startDateObj.getTime())
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
        if (diffDays > 60) {
            toast.error('El rango de fechas no puede ser mayor a 2 meses')
            return
        }
        if (res) {
            exportToExcel(res.data, 'Jugadores')
        }
        toast.dismiss()
        setLoadingExport(false)
    }


    return { exportToExcel, handleDownload, loadingExport }
}
